import CenteredMessage from './CenteredMessage';
export default CenteredMessage;



// WEBPACK FOOTER //
// ./src/components/CenteredMessage/index.js